import React from 'react'
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import useMarket from 'hooks/useMarket'

import styles from './SocialMediaButtons.module.css'

export default function SocialMediaButtons() {
  const market = useMarket()
  const { instagram, facebook } = market.config

  return (
    <div className={styles.wrapper}>
      <a
        className={styles.socialLink}
        href={`https://www.instagram.com/${instagram}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <FontAwesomeIcon icon={faInstagram} />
        <span style={{ paddingLeft: 5 }}>Instagram</span>
      </a>
      <a
        className={styles.socialLink}
        href={`https://www.facebook.com/${facebook}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <FontAwesomeIcon icon={faFacebook} />
        <span style={{ paddingLeft: 5 }}>Facebook</span>
      </a>
    </div>
  )
}
